// extracted by mini-css-extract-plugin
export default {"drawer-header-container":"JO_UCkEA5St1bVGjIbkY"};